export const MENU_WIDTH = 200
export const SHRINK_MENU_WIDTH = 56

export const TOP_BAR_HEIGHT = {
  lg: 64,
  sm: 56
}
